import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Pages/Page'
import { mediaPlatformPagesRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Pages'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Pages/Page'

export const mediaPlatformPageRoute = createRoute({
  getParentRoute: () => mediaPlatformPagesRoute,
  path: DynamicRouteParameterWPrefix.PAGE_ID,
  loader: () => ({
    crumb: t('entity:publishing.page', { count: 1 }),
  }),
})

export const mediaPlatformPageLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformPageRoute,
  id: 'mediaPlatformPageLayout',
  component: Structure,
})

export const mediaPlatformPageRawRoute = createRoute({
  getParentRoute: () => mediaPlatformPageLayoutRoute,
  path: '/',
  component: Overview,
})
